var _circle, _rect, _rect2, _rect3, _rect4, _g, _circle2, _g2, _g3, _g4, _g5, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThoughtful(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.9011,
    cy: 21.0762,
    r: 1.33008,
    fill: "url(#paint0_radial_2136_65357)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.38672,
    y: 16.6289,
    width: 5.08594,
    height: 5.03906,
    rx: 1.25,
    fill: "url(#paint1_linear_2136_65357)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.38672,
    y: 16.6289,
    width: 5.08594,
    height: 5.03906,
    rx: 1.25,
    fill: "url(#paint2_linear_2136_65357)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 9.38672,
    y: 16.6289,
    width: 5.08594,
    height: 5.03906,
    rx: 1.25,
    fill: "url(#paint3_radial_2136_65357)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 9.38672,
    y: 16.6289,
    width: 5.08594,
    height: 5.03906,
    rx: 1.25,
    fill: "url(#paint4_linear_2136_65357)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_2136_65357)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8255 17.2265C11.8396 17.2265 11.8532 17.2266 11.8661 17.2266C12.2825 17.2247 13.2415 17.2086 13.626 17.1387C14.0385 17.0637 14.0917 16.858 14.165 16.5352C14.6169 14.5451 15.3744 13.78 15.8812 13.2682C15.9593 13.1892 16.0315 13.1163 16.0957 13.0459C16.3156 12.8045 16.506 12.5919 16.6514 12.4279C17.7455 11.2667 18.416 9.70197 18.416 7.98064C18.416 4.39834 15.512 1.49431 11.9297 1.49431C8.34739 1.49431 5.44336 4.39834 5.44336 7.98064C5.44336 9.68098 6.09762 11.2285 7.16812 12.3852C7.31758 12.5543 7.52209 12.783 7.76159 13.0459C7.80325 13.0916 7.84827 13.1384 7.89613 13.1871C7.92199 13.2135 7.94868 13.2405 7.9761 13.2682C8.48291 13.78 9.24044 14.5451 9.69225 16.5352C9.76556 16.858 9.81882 17.0637 10.2313 17.1387C10.6149 17.2084 11.3912 17.2244 11.784 17.2264C11.7969 17.2264 11.8108 17.2265 11.8255 17.2265Z",
    fill: "url(#paint5_radial_2136_65357)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8255 17.2265C11.8396 17.2265 11.8532 17.2266 11.8661 17.2266C12.2825 17.2247 13.2415 17.2086 13.626 17.1387C14.0385 17.0637 14.0917 16.858 14.165 16.5352C14.6169 14.5451 15.3744 13.78 15.8812 13.2682C15.9593 13.1892 16.0315 13.1163 16.0957 13.0459C16.3156 12.8045 16.506 12.5919 16.6514 12.4279C17.7455 11.2667 18.416 9.70197 18.416 7.98064C18.416 4.39834 15.512 1.49431 11.9297 1.49431C8.34739 1.49431 5.44336 4.39834 5.44336 7.98064C5.44336 9.68098 6.09762 11.2285 7.16812 12.3852C7.31758 12.5543 7.52209 12.783 7.76159 13.0459C7.80325 13.0916 7.84827 13.1384 7.89613 13.1871C7.92199 13.2135 7.94868 13.2405 7.9761 13.2682C8.48291 13.78 9.24044 14.5451 9.69225 16.5352C9.76556 16.858 9.81882 17.0637 10.2313 17.1387C10.6149 17.2084 11.3912 17.2244 11.784 17.2264C11.7969 17.2264 11.8108 17.2265 11.8255 17.2265Z",
    fill: "url(#paint6_radial_2136_65357)"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.0964,
    cy: 5.21484,
    r: 2.49609,
    fill: "url(#paint7_linear_2136_65357)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_2136_65357)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6091 17.2248C11.5828 15.5956 11.453 14.5229 11.2553 13.7761C11.0275 12.9155 10.7089 12.4865 10.3718 12.1464L10.3676 12.1421L10.3632 12.138C9.93144 11.7295 9.66284 11.1523 9.66284 10.5117C9.66284 9.27555 10.6649 8.27344 11.9011 8.27344C13.1373 8.27344 14.1394 9.27555 14.1394 10.5117C14.1394 11.1523 13.8708 11.7295 13.439 12.138L13.4347 12.1421L13.4304 12.1464C13.0994 12.4804 12.7765 12.8812 12.5459 13.7348C12.3465 14.4732 12.216 15.5498 12.1901 17.2231C12.4162 17.2195 12.6868 17.2126 12.9405 17.2002C12.9673 15.5743 13.095 14.5784 13.27 13.9303C13.4597 13.2281 13.7034 12.9369 13.9591 12.6784C14.5316 12.1345 14.8894 11.3646 14.8894 10.5117C14.8894 8.86134 13.5515 7.52344 11.9011 7.52344C10.2507 7.52344 8.91284 8.86134 8.91284 10.5117C8.91284 11.3645 9.27059 12.1344 9.84313 12.6784C10.0928 12.9311 10.3394 13.2467 10.5303 13.968C10.7047 14.627 10.8313 15.6211 10.8585 17.2007C11.1183 17.2151 11.3922 17.2219 11.6091 17.2248Z",
    fill: "#FFAD55"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_2136_65357)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6592 17.0539C12.6592 13.4756 13.2075 12.9049 13.7956 12.3114C14.2991 11.835 14.6133 11.1606 14.6133 10.4127C14.6133 8.96945 13.4433 7.79944 12 7.79944C10.5567 7.79944 9.38672 8.96945 9.38672 10.4127C9.38672 11.1606 9.70086 11.835 10.2044 12.3114C10.7925 12.9049 11.3379 13.9321 11.3379 17.0539",
    stroke: "url(#paint8_linear_2136_65357)",
    strokeWidth: 0.25
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_2136_65357)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9.32251,
    y: 18.8421,
    width: 5.10837,
    height: 0.802779,
    rx: 0.401389,
    transform: "rotate(-8.90493 9.32251 18.8421)",
    fill: "#7E6693"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_2136_65357)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9.32251,
    y: 20.6205,
    width: 5.10837,
    height: 0.802779,
    rx: 0.401389,
    transform: "rotate(-8.90493 9.32251 20.6205)",
    fill: "#7E6693"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 8.76343,
    y: 20.5972,
    width: 6.24022,
    height: 0.826362,
    rx: 0.413181,
    transform: "rotate(-8.90494 8.76343 20.5972)",
    fill: "url(#paint9_linear_2136_65357)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 8.76343,
    y: 20.5972,
    width: 6.24022,
    height: 0.826362,
    rx: 0.413181,
    transform: "rotate(-8.90494 8.76343 20.5972)",
    fill: "url(#paint10_linear_2136_65357)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 8.76343,
    y: 20.5972,
    width: 6.24022,
    height: 0.826362,
    rx: 0.413181,
    transform: "rotate(-8.90494 8.76343 20.5972)",
    fill: "url(#paint11_linear_2136_65357)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 8.76343,
    y: 20.5972,
    width: 6.24022,
    height: 0.826362,
    rx: 0.413181,
    transform: "rotate(-8.90494 8.76343 20.5972)",
    fill: "url(#paint12_radial_2136_65357)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 8.76343,
    y: 18.8149,
    width: 6.24022,
    height: 0.826362,
    rx: 0.413181,
    transform: "rotate(-8.90494 8.76343 18.8149)",
    fill: "url(#paint13_linear_2136_65357)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 8.76343,
    y: 18.8149,
    width: 6.24022,
    height: 0.826362,
    rx: 0.413181,
    transform: "rotate(-8.90494 8.76343 18.8149)",
    fill: "url(#paint14_linear_2136_65357)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 8.76343,
    y: 18.8149,
    width: 6.24022,
    height: 0.826362,
    rx: 0.413181,
    transform: "rotate(-8.90494 8.76343 18.8149)",
    fill: "url(#paint15_linear_2136_65357)"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 8.76343,
    y: 18.8149,
    width: 6.24022,
    height: 0.826362,
    rx: 0.413181,
    transform: "rotate(-8.90494 8.76343 18.8149)",
    fill: "url(#paint16_radial_2136_65357)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_2136_65357",
    x: 5.44336,
    y: 1.49431,
    width: 13.2227,
    height: 15.8823,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.25,
    dy: 0.15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.666667 0 0 0 0 0.309804 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2136_65357"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_2136_65357",
    x: 8.91284,
    y: 7.52344,
    width: 6.22656,
    height: 9.70132,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.572549 0 0 0 0 0.254902 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2136_65357"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_2136_65357",
    x: 9.01172,
    y: 7.42444,
    width: 5.97656,
    height: 9.87949,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.125,
    result: "effect1_foregroundBlur_2136_65357"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_2136_65357",
    x: 9.12964,
    y: 17.8586,
    width: 5.55664,
    height: 1.96939,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.125,
    result: "effect1_foregroundBlur_2136_65357"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_2136_65357",
    x: 9.12964,
    y: 19.637,
    width: 5.55664,
    height: 1.96939,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.125,
    result: "effect1_foregroundBlur_2136_65357"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2136_65357",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.2527 21.832) rotate(96.6544) scale(0.707894 1.63961)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.267752,
    stopColor: "#AC90C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E6AAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2136_65357",
    x1: 14.4727,
    y1: 19.3511,
    x2: 9.38672,
    y2: 19.3511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDC2D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#947C8D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2136_65357",
    x1: 9.13561,
    y1: 19.7344,
    x2: 10.3778,
    y2: 19.7344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A7B88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A7B88",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_2136_65357",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.9785 16.9803) rotate(88.6361) scale(0.618651 2.75431)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.228769,
    stopColor: "#EDE2EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C8BCCB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2136_65357",
    x1: 13.0965,
    y1: 21.668,
    x2: 13.0965,
    y2: 20.7187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E5F9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E5F9E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_2136_65357",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.6669 6.09375) rotate(138.066) scale(7.43527 6.13105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.286168,
    stopColor: "#FFEC87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCD4B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_2136_65357",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.37 10.0781) rotate(-147.604) scale(10.9365 10.5194)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.622387,
    stopColor: "#FFB239",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB239"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2136_65357",
    x1: 12.2235,
    y1: 6.02056,
    x2: 14.7896,
    y2: 4.02097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594121,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2136_65357",
    x1: 14.7897,
    y1: 8.248,
    x2: 11.7857,
    y2: 15.4047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBF5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBF5C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2136_65357",
    x1: 11.808,
    y1: 20.6042,
    x2: 11.867,
    y2: 21.5149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1969A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAD2E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2136_65357",
    x1: 12.5364,
    y1: 21.4063,
    x2: 12.5344,
    y2: 20.8129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A68A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEC2E3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2136_65357",
    x1: 8.6902,
    y1: 21.0646,
    x2: 10.7806,
    y2: 20.9533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#958387"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#958387",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_2136_65357",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.9356 20.8794) rotate(90.3213) scale(0.62813 3.71783)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.126697,
    stopColor: "#FCF0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5C9E3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2136_65357",
    x1: 11.808,
    y1: 18.8218,
    x2: 11.867,
    y2: 19.7326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1969A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAD2E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2136_65357",
    x1: 12.5364,
    y1: 19.6239,
    x2: 12.5344,
    y2: 19.0305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A68A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEC2E3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2136_65357",
    x1: 8.6902,
    y1: 19.2823,
    x2: 10.7806,
    y2: 19.1709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#958387"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#958387",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_2136_65357",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.9356 19.097) rotate(90.3213) scale(0.62813 3.71783)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.126697,
    stopColor: "#FCF0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5C9E3",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThoughtful);
export default __webpack_public_path__ + "static/media/thoughtful.3f531e6d.svg";
export { ForwardRef as ReactComponent };